import { apiRequest } from './client';
import { catalogConfig } from '../config/catalog';

export default async function getSkuById(id_sku) {
  return apiRequest(`/search/v2/sku/${id_sku}`, {
    params: { cnpj: catalogConfig.cnpj },
  });
}
